import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { FC } from 'react'

import Loading from 'components/Loading'
import { Event, LoggedInUser, Participant, Toast } from 'models/API'

import Item from './Item'

interface Props {
  loading: boolean
  event: Event
  participants: Participant[]
  loggedInUser: LoggedInUser
  toast: (toast: Toast) => void
}

const Results: FC<Props> = ({
  event,
  participants,
  loading,
  loggedInUser,
  toast,
}) => (
  <Paper sx={{ pb: 1, px: 3 }}>
    <Typography variant="overline" sx={{ mb: 4, pb: 4 }}>
      PARTICIPANTS
    </Typography>
    <Loading loading={loading} desc="Fetching participants" />
    {!loading && (
      <Box sx={{ my: 3 }}>
        {(participants || [])
          .sort((a: Participant, b: Participant) =>
            a.firstName.localeCompare(b.firstName),
          )
          .map((participant: Participant, index) => (
            <Item
              key={`participant-${participant.id}`}
              data={participant}
              event={event}
              index={index}
              loggedInUser={loggedInUser}
              toast={toast}
            />
          ))}
        {participants.length === 0 && (
          <Typography m={2} textAlign="center">
            No results...
          </Typography>
        )}
      </Box>
    )}
  </Paper>
)

export default Results
